<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="reportSource">Report Source</label>
                    <wj-combo-box
                        id="reportSource"
                        [(ngModel)]="target.reportSource"
                        name="reportSource"
                        [itemsSource]="reportSourceOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="labName">Lab Name</label>
                    <input type="text" class="form-control" id="labName" [(ngModel)]="target.labName" name="labName" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="reportNumber">Report Number</label>
                    <input type="text" class="form-control" id="reportNumber" [(ngModel)]="target.reportNumber" name="reportNumber" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="inspector">Inspector</label>
                    <input type="text" class="form-control" id="inspector" [(ngModel)]="target.inspector" name="inspector" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="sampleDate">Sample Date</label>
                    <input type="text" class="form-control" id="sampleDate" [(ngModel)]="target.sampleDate" name="sampleDate" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="reportDate">Report Date</label>
                    <input type="text" class="form-control" id="reportDate" [(ngModel)]="target.reportDate" name="reportDate" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="pourDate">Pour Date</label>
                    <input type="text" class="form-control" id="pourDate" [(ngModel)]="target.pourDate" name="pourDate" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="setNo">Set No</label>
                    <input type="text" class="form-control" id="setNo" [(ngModel)]="target.setNo" name="setNo" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="pourLocation">Pour Location</label>
                    <input type="text" class="form-control" id="pourLocation" [(ngModel)]="target.pourLocation" name="pourLocation" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="mixNo">Mix No</label>
                    <input type="text" class="form-control" id="mixNo" [(ngModel)]="target.mixNo" name="mixNo" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="supplier">Supplier</label>
                    <wj-combo-box
                        id="supplier"
                        [(ngModel)]="target.supplier"
                        name="supplier"
                        [itemsSource]="concreteVendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="specifiedPsi">Specified PSI</label>
                    <input type="text" class="form-control" id="specifiedPsi" [(ngModel)]="target.specifiedPsi" name="specifiedPsi" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="ticketNo">Ticket No</label>
                    <input type="text" class="form-control" id="ticketNo" [(ngModel)]="target.ticketNo" name="ticketNo" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="truckNo">Truck No</label>
                    <input type="text" class="form-control" id="truckNo" [(ngModel)]="target.truckNo" name="truckNo" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="plant">Plant</label>
                    <input type="text" class="form-control" id="plant" [(ngModel)]="target.plant" name="plant" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="airTempF">Air Temp (F)</label>
                    <input type="text" class="form-control" id="airTempF" [(ngModel)]="target.airTempF" name="airTempF" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="concreteTempF">Concrete Temp (F)</label>
                    <input type="text" class="form-control" id="concreteTempF" [(ngModel)]="target.concreteTempF" name="concreteTempF" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="slump">Slump</label>
                    <input type="text" class="form-control" id="slump" [(ngModel)]="target.slump" name="slump" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="airContentPct">Air Content (%)</label>
                    <input type="text" class="form-control" id="airContentPct" [(ngModel)]="target.airContentPct" name="airContentPct" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="unitWeightPcf">Unit Weight (pcf)</label>
                    <input type="text" class="form-control" id="unitWeightPcf" [(ngModel)]="target.unitWeightPcf" name="unitWeightPcf" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="waterAdded">Water Added</label>
                    <input type="text" class="form-control" id="waterAdded" [(ngModel)]="target.waterAdded" name="waterAdded" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="yieldCuYds">Yield (cu yds)</label>
                    <input type="text" class="form-control" id="yieldCuYds" [(ngModel)]="target.yieldCuYds" name="yieldCuYds" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="numberOfSpecimens">No. of Specimens</label>
                    <input
                        type="text"
                        class="form-control"
                        id="numberOfSpecimens"
                        [(ngModel)]="target.numberOfSpecimens"
                        name="numberOfSpecimens"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="weather">Weather</label>
                    <input type="text" class="form-control" id="weather" [(ngModel)]="target.weather" name="weather" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="startTime">Start Time</label>
                    <input type="text" class="form-control" id="startTime" [(ngModel)]="target.startTime" name="startTime" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="stopTime">Stop Time</label>
                    <input type="text" class="form-control" id="stopTime" [(ngModel)]="target.stopTime" name="stopTime" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="standardHours">Standard Hours</label>
                    <input type="text" class="form-control" id="standardHours" [(ngModel)]="target.standardHours" name="standardHours" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="overtimeHours">Overtime Hours</label>
                    <input type="text" class="form-control" id="overtimeHours" [(ngModel)]="target.overtimeHours" name="overtimeHours" />
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <div class="form-group">
                    <label for="travelHours">Travel Hours</label>
                    <input type="text" class="form-control" id="travelHours" [(ngModel)]="target.travelHours" name="travelHours" />
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label for="remarks">Remarks</label>
                    <textarea class="form-control" id="remarks" rows="2" [(ngModel)]="target.remarks" name="remarks"></textarea>
                </div>
            </div>
        </div>

        <hr />
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">Cylinder Break Results</h5>
            <div>
                <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="addSpecimen()">Add Row</button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteSpecimen()">Delete Row</button>
            </div>
        </div>
        <wj-flex-grid
            #specimenGridRef
            style="height: 220px"
            (initialized)="specimenGrid.initialize(specimenGridRef)"
            [itemsSource]="specimenGrid.view"
        >
            <wj-flex-grid-column [header]="'Specimen ID'" [binding]="'specimenId'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Date Tested'" [binding]="'dateTested'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Age (days)'" [binding]="'ageDays'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Avg Diameter'" [binding]="'avgDiameter'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Area (in2)'" [binding]="'areaSqIn'" [width]="90"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Max Load (lbs)'" [binding]="'maxLoadLbs'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Strength (PSI)'" [binding]="'strengthPsi'" [width]="110"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'% of Spec'" [binding]="'percentOfSpec'" [width]="80"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Fracture Type'" [binding]="'fractureType'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Cap Type'" [binding]="'capType'" [width]="90"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Tested By'" [binding]="'testedBy'" width="*"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
